import api from 'config/api.config';
import { AxiosResponse } from 'axios';

export interface InstagramSearchResult {
  username: string;
  full_name: string;
  profile_pic_url: string;
  id: number;
  is_private: boolean;
  is_verified: boolean;
  friendship_status?: {
    following: boolean;
    is_bestie: boolean;
    is_feed_favorite: boolean;
    is_private: boolean;
    is_restricted: boolean;
    incoming_request: boolean;
    outgoing_request: boolean;
  };
}

export const searchInstagramUsers = async (query: string): Promise<InstagramSearchResult[]> => {
  const response: AxiosResponse<InstagramSearchResult[]> = await api.post(
    '/api/instagram/search',
    { social_media_account_id: '6973261259ae2d2c5d3193f6' },
    { params: { query, type: 'user' } }
  );

  return response.data;
};

export const searchInstagramUsersPublic = async (query: string): Promise<InstagramSearchResult[]> => {
  const response: AxiosResponse<InstagramSearchResult[]> = await api.get(
    '/api/instagram/search-public',
    { params: { query, type: 'user' } }
  );

  return response.data;
};
